import type { SaveMode } from '@trove/contracts';
import type { DiffViewMode } from './locDiff';

const SAVE_MODE_KEY = 'trove-save-mode';
const FILE_LIST_DENSITY_KEY = 'trove-file-list-density';
const DIFF_VIEW_MODE_KEY = 'trove-diff-view-mode';
const CLI_GUIDE_DISMISSED_KEY = 'trove-cli-guide-dismissed';

export type FileListDensity = 'compact' | 'comfy';
export type DiffViewModePreference = DiffViewMode;

export function loadSaveMode(): SaveMode {
  try {
    const value = localStorage.getItem(SAVE_MODE_KEY);
    if (value === 'queued' || value === 'immediate') return value;
  } catch {
    // Ignore storage failures (private mode, etc.)
  }
  return 'immediate';
}

export function saveSaveMode(mode: SaveMode): void {
  localStorage.setItem(SAVE_MODE_KEY, mode);
}

export function loadFileListDensity(): FileListDensity {
  try {
    const value = localStorage.getItem(FILE_LIST_DENSITY_KEY);
    if (value === 'compact' || value === 'comfy') return value;
  } catch {
    // Ignore storage failures (private mode, etc.)
  }
  return 'comfy';
}

export function saveFileListDensity(density: FileListDensity): void {
  try {
    localStorage.setItem(FILE_LIST_DENSITY_KEY, density);
  } catch {
    // Ignore storage failures (private mode, etc.)
  }
}

export function loadDiffViewMode(): DiffViewModePreference {
  try {
    const value = localStorage.getItem(DIFF_VIEW_MODE_KEY);
    if (value === 'unified' || value === 'split') return value;
  } catch {
    // Ignore storage failures (private mode, etc.)
  }
  return 'unified';
}

export function saveDiffViewMode(mode: DiffViewModePreference): void {
  try {
    localStorage.setItem(DIFF_VIEW_MODE_KEY, mode);
  } catch {
    // Ignore storage failures (private mode, etc.)
  }
}

export function loadCliGuideDismissed(): boolean {
  try {
    return localStorage.getItem(CLI_GUIDE_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function saveCliGuideDismissed(dismissed: boolean): void {
  try {
    if (dismissed) localStorage.setItem(CLI_GUIDE_DISMISSED_KEY, '1');
    else localStorage.removeItem(CLI_GUIDE_DISMISSED_KEY);
  } catch {
    // Ignore storage failures (private mode, etc.)
  }
}
